/**
 * Utility functions for number formatting
 */

/**
 * Formats a number with comma separators for thousands
 * @param {number|string} num - The number to format
 * @param {string} locale - The locale to use for formatting (default: 'en-US')
 * @returns {string} - The formatted number string
 */
export const formatNumber = (num, locale = 'en-US') => {
    return Number(num).toLocaleString(locale);
};

/**
 * Formats a number with comma separators and specific decimal places
 * @param {number|string} num - The number to format
 * @param {number} decimals - Number of decimal places (default: 4)
 * @param {string} locale - The locale to use for formatting (default: 'en-US')
 * @returns {string} - The formatted number string
 */
export const formatNumberWithDecimals = (num, decimals = 4, locale = 'en-US') => {
    return Number(num).toLocaleString(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
};

/**
 * Formats a number with currency format
 * @param {number|string} num - The number to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @param {string} locale - The locale to use for formatting (default: 'en-US')
 * @returns {string} - The formatted number string
 */
export const formatCurrency = (num, decimals = 2, locale = 'en-US') => {
    return Number(num).toLocaleString(locale, {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
};

